import { Tab, Tabs } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CopyButton from 'components/CopyButton';
import DownloadButton from 'components/DownloadButton';
import { getSelectedSupplier } from 'features/settings/settingsSlice';
import SupplierSelection from 'features/settings/SupplierSelection';
import { getCurrentCart } from 'features/shoppingCart/shoppingCartSlice';
import flatten from 'lodash/flatten';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionsContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& > :not(:last-child)': {
        marginRight: theme.spacing(4),
      },
    },
    copyContainer: {
      minWidth: 366,
    },
    code: {
      textAlign: 'left',
      border: '1px solid #eee',
      borderRadius: 5,
      padding: theme.spacing(2),
      backgroundColor: theme.palette.grey[100],
    },
  }),
);

const CartActions = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const cart = useSelector(getCurrentCart);
  const selectedSupplier = useSelector(getSelectedSupplier);
  const [tab, setTab] = useState<number>(0);
  // If all suppliers are selected (selectedSupplier is undefined) then all items are selected
  const selectedItems = flatten(cart?.items.map((item) => item.selectedItems)).filter(
    (item) => !(selectedSupplier && item.supplier !== selectedSupplier.name),
  );

  const copyDump = selectedItems
    .map((item) => (tab ? `${item.smiles}\t` : '') + item.displayCode)
    .join('\n');

  const handleModeChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  let tsvArray = [['Smiles', 'Product Code']];
  selectedItems.forEach((item) => tsvArray.push([item.smiles, item.displayCode]));

  const tsvDump = tsvArray.map((row) => row.join('\t')).join('\n');

  return (
    <section className={classes.actionsContainer}>
      <div className={classes.copyContainer}>
        <Tabs
          value={tab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleModeChange}
          centered
        >
          <Tab label={t('cart:codes')} />
          <Tab label={t('cart:smiles_and_codes')} />
        </Tabs>
        <pre className={classes.code}>{copyDump}</pre>
        <CopyButton dump={copyDump} tooltip={t('cart:copy_list')!} />
        <DownloadButton
          filename={`${cart.name}.tsv`}
          dump={tsvDump}
          tooltip={t('cart:download_list')}
        />
      </div>
      <SupplierSelection />
    </section>
  );
};

export default CartActions;
